module.exports = __webpack_public_path__ + "img/coin-lock.90e0c6e2.png";